var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"my-0 py-0",attrs:{"fluid":""}},[_c('v-card',{staticClass:"mt-3",attrs:{"elevation":8}},[_c('ProduzioneLayout',{attrs:{"commessa":{},"filtroEM":'1',"rotta_back":_vm.rotta_back,"work_order_sempre_aperto":false}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }